export const ORDER_IMPORT_FORM_NAME = 'order_import';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const IMPORT_ORDERS_FORM_REQUIRED_FIELDS = ['file'];
